import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import { NetworkLink } from '../link';

import * as authActions from '../../../actions/authentication/authentication';
import * as basketActions from '../../../actions/transactions/basket';
import * as notificationActions from '../../../actions/notifications/notifications';
import { Loader } from "./";
import { siteOfOriginHelper } from '../../../helpers/genericHelpers';

class MobileHeader extends Component {

    componentDidMount() {
        const { getMessageNotifications } = this.props;

        getMessageNotifications();
    };

    logoutUser = () => {
        const { logoutUser } = this.props;

        logoutUser();
        browserHistory.push( '/login' );
    };

    render () {
        const { basket, messages, isLoggedIn } = this.props;

        let basketCount = 0;

        if( basket ){
            const productCount = basket.products.length,
                packageCount = basket.packages.length;

            basketCount = productCount + packageCount
        }

        if( !basket ) {
            return (
                <Loader />
            );
        }

        let messageCount;

        if( messages.length > 0 ) {
            messageCount = messages[0].count;
        } else {
            messageCount = 0;
        }

        const siteOfOrigin = siteOfOriginHelper();

        return (
            <div className="container-fluid padding-none" aria-label="Primary navigation">
                <article className="header-main" id="mobile-nav">
                    <div className="row margin-none">
                        <div className="col-xs-12 col-sm-3 col-md-5 col-lg-4 header-logo-box">
                            <Link to={ '/' }>
                                <div className="itn-logo "> </div>
                            </Link>
                        </div>
                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#main-nav-collapse" aria-expanded="false">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"> </span>
                            <span className="icon-bar"> </span>
                            <span className="icon-bar"> </span>
                        </button>
                        <div className="col-xs-12 col-sm-6 col-md-5 col-lg-4 header-controls-box">
                            <ul className="header-menu">
                                <li className="item-controls-networks">
                                    <button data-toggle="collapse" data-target="#activitiesOverlay">
                                        <img src={ `/images/ITN.png` } alt="Network logo"/>
                                    </button>
                                </li>
                                <li className="item-controls-conversation">
                                    <NetworkLink logout={ false } link={ '/networking/conversations' } src="/images/icons/mail.png" notifications={ messageCount } buttonBadge={ messageCount !== 0 } />
                                </li>
                                <li className="item-controls-help">
                                  <a target="blank" href={ `https://intouchnetworks.zendesk.com/hc/en-gb` }>
                                    <div><img src="/images/icons/help.png" alt=""/></div>
                                  </a>
                                </li>
                                <li className="item-controls-basket">
                                    <NetworkLink logout={ false } link={ '/basket' } src="/images/icons/basket.png" notifications={ basketCount } buttonBadge={ basketCount !== 0 } />
                                </li>
                                <li className="item-controls-settings">
                                    <NetworkLink logout={ false } link={ '/account/basic' } src={ '/images/icons/settings.png' } buttonBadge={ false } />
                                </li>
                                {
                                    isLoggedIn ?
                                        <li className="item-controls-user itn-menu-item">
	                                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#secondary-nav-collapse" aria-expanded="false">
                                                <span className="icon-user">
                                                    <NetworkLink logout={ false } src="/images/icons/logout.png" notifications={ messageCount } buttonBadge={ messageCount !== 0 } />
                                                </span>
                                            </button>
                                            {/*<div data-toggle="collapse" data-target="#secondary-nav-collapse">
                                                <span className="icon-login">
                                                    <NetworkLink logout={ true } src="/images/icons/logout.png" notifications={ false } buttonBadge={ false } logoutFunction={ this.logoutUser } />
                                                </span>
                                            </div>*/}
                                        </li>
                                        :
                                        /*todo: mm - check this*/
                                      <li>
                                        <a target="blank" href={ `https://intouchnetworks.zendesk.com/hc/en-gb` }>
                                          <div><img src="/images/icons/help.png"/></div>
                                        </a>
                                      </li>
                                }
                            </ul>
                        </div>
                        <div className="col-xs-12 col-sm-11 col-sm-offset-1">
                            <nav className="user-area collapse navbar-collapse" id="secondary-nav-collapse">
                                <ul className="nav navbar-nav">
                                    <li>
                                        <Link to={ '/profile' } data-toggle="collapse" data-target="#secondary-nav-collapse">My Profile</Link>
                                    </li>
                                    <li>
                                        <Link to={ '/networking/conversations' } data-toggle="collapse" data-target="#secondary-nav-collapse">Messages<span>{ messageCount !== 0 }</span></Link>
                                    </li>
                                    <li>
                                        <Link to={ '/account/basic' } data-toggle="collapse" data-target="#secondary-nav-collapse">Settings</Link>
                                    </li>
                                  <li>
                                    <Link target="blank" to={ `https://intouchnetworks.zendesk.com/hc/en-gb` }>
                                      Help
                                    </Link>
                                  </li>
                                    {
                                        isLoggedIn ?
                                            <li className="item-controls-login" >
                                                <NetworkLink logout={ true } src="/images/icons/logout.png" notifications={ false } buttonBadge={ false } logoutFunction={ this.logoutUser } data-toggle="collapse" data-target="#secondary-nav-collapse" />
                                            </li>
                                            : null
                                    }
                                </ul>
                            </nav>
                        </div>
                    </div>
                </article>
            </div>
        );
    }
}

MobileHeader.propTypes = {
    // network: PropTypes.string.isRequired,
    basket: PropTypes.object.isRequired,
    messages: PropTypes.array.isRequired,
    // isLoggedIn: PropTypes.string.isRequired,
    logoutUser: PropTypes.func.isRequired,
};

const mapStateToProps = ( state ) => {
    return {
        basket: state.transactions.basket,
        isLoggedIn: state.authentication.isLoggedIn,
        hasErrored: state.authentication.error.hasErrored,
        errorCode: state.authentication.error.errorCode,
        messages: state.notifications.messages,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        loginUser: () => dispatch( authActions.loginUser() ),
        logoutUser: () => dispatch( authActions.logoutUser() ),
        getBasket: () => dispatch( basketActions.getBasket() ),
        getMessageNotifications: () => dispatch( notificationActions.getMessageNotifications() ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( MobileHeader );



// WEBPACK FOOTER //
// src/client/components/common/elements/MobileHeader.js